import React, { useState, useEffect, useMemo } from 'react';
import { url } from '../../utils/variables';
import ImagePickerModal from '../master/ImagePickerModal';
import Modal from '../master/Modal';
// import defaultImage from '../../assets/images/default.png';
import defaultImage from '../../assets/images/add-image-orange2.png';
import { useTranslation } from 'react-i18next';
import ImageZoom from '../master/ImageZoom';
import AddImageOutline from '../../assets/images/add-image-outline.png'

export default function ExpertImage({ title, upload, src ,label ,required}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [image, setImage] = useState(null);
    const [expertImage, setExpertImage] = useState(null);

    const dataProps = useMemo(() => JSON.stringify({value : expertImage, required, label : title}), [title, required, expertImage]);
    
    useEffect(() => {
        src.forEach(itm => {
            if (itm.filename.includes('expert')) setExpertImage(itm);
            else setImage(itm);
        });
    }, [src]);

    return (
        <>
            <Modal visible={ showModal }>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={ () => setShowModal(false) }
                    />
                    {/* <img src={image && `${url}/files?uid=${image.uid}`} alt='img' /> */}
                    <ImageZoom imgUid={image && image.uid}/>
                </div>
            </Modal>
            <div className='docsGrid' data-props={t(dataProps)}>
                <div className='gridChild'>
                    <p>
                        { title } 
                        {
                            required &&
                            <span className='required-icon'> * </span>
                        }
                    </p>
                    <div className='imgParent'>
                        <div className='flex1 pl5'>
                            <img
                                src={ image ? `${url}/files?uid=${image.uid}&width=150&height=150` : defaultImage }
                                className={`img ${!image && 'default-img'}`}
                                alt='img'
                                onClick={ () => image && setShowModal(true) }
                            />
                        </div>
                        <div className='flex1'>
                            <ImagePickerModal
                                renderBtn={
                                    expertImage ?
                                    <img
                                        src={`${url}/files?uid=${expertImage.uid}&width=150&height=150`}
                                        className='img'
                                        alt='img'
                                    />
                                    : 
                                    // <div className='upload-icon-parent'>
                                    //     <img src={AddImageOutline}/>
                                    // </div>
                                    'default'
                                    //<div className='defaultImage' data-content={t('Add')}/>
                                }
                                disableGallery
                                upload={upload}
                                label={label}
                                imageUid={expertImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};
